module.exports = __webpack_public_path__ + "static/media/click3.b9c0e1f8.mp3";